import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "../hooks/use-toast";
import AuthLayout from "../components/AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast({ title: "Welcome back", description: `Signed in as ${u.name}` });
      nav(u.role === "super_admin" ? "/admin" : u.role === "venue" ? "/venue" : u.role === "staff" ? "/door" : u.role === "fan" ? "/following" : u.role === "artist" ? "/artist" : "/dashboard");
    } catch (err) {
      toast({ title: "Login failed", description: err?.response?.data?.detail || "Check your credentials", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to manage your events and ticket sales.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[#16243b] mb-1.5">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
            className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="you@business.com" />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#16243b] mb-1.5">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
            className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="••••••••" />
        </div>
        <button disabled={loading} data-testid="login-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="text-sm text-right mt-3">
        <Link to="/forgot-password" className="text-[#1fb0b0] font-medium hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
      </p>
      <p className="text-xs text-right mt-1">
        <Link to="/venue-forgot" className="text-[#5a6b80] hover:text-[#1fb0b0] hover:underline" data-testid="venue-forgot-link">Venue door staff? Reset access</Link>
      </p>
      <p className="text-sm text-[#5a6b80] mt-6 text-center">
        New to TicketsPro.app? <Link to="/signup" className="text-[#1fb0b0] font-medium hover:underline">Create an account</Link>
      </p>
      <p className="text-xs text-[#8a97a8] mt-2 text-center">
        Performer or DJ? <Link to="/artist-signup" className="text-[#1fb0b0] font-medium hover:underline" data-testid="artist-signup-link">Create an artist profile</Link>
      </p>
    </AuthLayout>
  );
}
